import { Card } from "~/components/Card"
import { Button } from "~/components/Button"

interface PrivateBrowsingWarningProps {
	onDismiss: () => void
}

export function PrivateBrowsingWarning({ onDismiss }: PrivateBrowsingWarningProps) {
	const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
	const isAndroid = /Android/.test(navigator.userAgent)
	
	const iosTutorialUrl = "https://www.youtube.com/watch?v=XkR8aJfzeho"
	const androidTutorialUrl = "https://www.youtube.com/watch?v=T44Wg1WHgmc"
	
	return (
		<Card className="bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800 p-4">
			<div className="flex items-start gap-3">
				<span className="text-2xl shrink-0">⚠️</span>
				<div className="flex-1 flex flex-col gap-3">
					<h2 className="font-semibold text-amber-900 dark:text-amber-100 text-sm">
						Privacy Settings Detected
					</h2>
					<p className="text-xs text-amber-800 dark:text-amber-200">
						Private browsing or advanced privacy protections may cause repeated logins and actions may not register. Switch to regular browsing or reduce privacy protections for the best experience.
					</p>
					
					<div className="p-3 bg-amber-100 dark:bg-amber-900/30 rounded border border-amber-200 dark:border-amber-700">
						<p className="font-semibold text-amber-900 dark:text-amber-100 text-xs mb-2">How to fix:</p>
						{isIOS ? (
							<>
								<ol className="list-decimal list-inside space-y-1 text-xs text-amber-800 dark:text-amber-200 mb-2">
									<li>If you see Safari's privacy warning, tap "Reduce Protections"</li>
									<li>Or: Open Safari and tap the Tabs button (two squares)</li>
									<li>Tap off of "Private" to the normal tabs, then "Done"</li>
								</ol>
								<a
									href={iosTutorialUrl}
									target="_blank"
									rel="noopener noreferrer"
									className="text-xs text-amber-700 dark:text-amber-300 underline font-medium"
								>
									Watch iOS tutorial →
								</a>
							</>
						) : isAndroid ? (
							<>
								<ol className="list-decimal list-inside space-y-1 text-xs text-amber-800 dark:text-amber-200 mb-2">
									<li>Open Chrome and tap the three dots menu</li>
									<li>Tap "New incognito tab" to see if incognito is active</li>
									<li>Close incognito tabs and use a regular tab</li>
								</ol>
								<a
									href={androidTutorialUrl}
									target="_blank"
									rel="noopener noreferrer"
									className="text-xs text-amber-700 dark:text-amber-300 underline font-medium"
								>
									Watch Android tutorial →
								</a>
							</>
						) : (
							<ol className="list-decimal list-inside space-y-1 text-xs text-amber-800 dark:text-amber-200">
								<li>Close any Private Browsing windows</li>
								<li>Open a new regular browser window</li>
							</ol>
						)}
					</div>
					
					<Button
						onClick={onDismiss}
						className="w-full bg-amber-600 hover:bg-amber-700 text-white border-0 text-xs h-10"
					>
						Got it
					</Button>
				</div>
			</div>
		</Card>
	)
}

